import { Box, Flex } from "@otrium/core";
import { Skeleton } from "src/atoms/Skeleton";

const CartSectionSkeleton = (): JSX.Element => (
  <Box height="280px" width="100%" maxWidth="544px" m="auto">
    <Skeleton />
  </Box>
);

const CartViewSkeleton = (): JSX.Element => (
  <>
    <Flex
      data-testid="cart-skeleton"
      mx={-2}
      flexDirection="column"
      alignItems="center"
    >
      <Box
        mt={4}
        px={[0, 0, 0, 2, 2]}
        ml={[0, 0, 0, 4, 4]}
        width="100%"
        maxWidth="1160px"
      >
        <CartSectionSkeleton />
      </Box>
      <Box
        mt={4}
        px={[0, 0, 0, 2, 2]}
        ml={[0, 0, 0, 4, 4]}
        width="100%"
        maxWidth="1160px"
      >
        <CartSectionSkeleton />
      </Box>
      <Box
        mt={4}
        px={[0, 0, 0, 2, 2]}
        ml={[0, 0, 0, 4, 4]}
        mb={4}
        width="100%"
        maxWidth="1160px"
      >
        <CartSectionSkeleton />
      </Box>
    </Flex>
  </>
);

export default CartViewSkeleton;
